export default
{
	icons: [
		{
			name: "blinds",
			x: 1142,
			y: 315
		},
		{
			name: "clock",
			x: 1605,
			y: 99
		},
		{
			name: "whiteboard",
			x: 1726,
			y: 440.05
		},
		{
			name: "drip",
			x: 720.95,
			y: 328.9
		},
		{
			name: "breakfast",
			x: 394,
			y: 553.05
		},
		{
			name: "talk2pat",
			x: 497,
			y: 424.05
		},
		{
			name: "exit",
			x: 978,
			y: 960.05
		},
		{
			name: "zweedseBand",
			x: 642,
			y: 540.05
		},
		{
			name: "glasses",
			x: 324,
			y: 557.05
		},
		{
			name: "medication",
			x: 602,
			y: 464.5
		},
		{
			name: "water",
			x: 205.5,
			y: 539.55
		},
		{
			name: "shower",
			x: 800,
			y: 558.05
		},
		{
			name: "cad",
			x: 562.95,
			y: 751
		}
	],
	objects: [
		{
			name: "clock",
			x: 1569,
			y: 0
		},
		{
			name: "whiteboard",
			x: 1546,
			y: 534.45
		}
	]
}